import React from 'react';
import { LeadnowList } from 'app/components/anwendungen/leadnow/LeadnowList';
import { ITreeNodeModel } from './core/tree.node.model';
import { LeiterSpeziSteartIds, SpeziSteartIds, Steart } from './core/steart.model';

export const AnwendungeTreeNodes: ITreeNodeModel = {
	name: 'root',
	icon: 'root',
	path: '',
	nodes: [
		{
			name: 'Branchenplanung',
			icon: 'chart-pie',
			path: 'bp',
			nodes: [],
			visibileForRoles: [Steart.VBL, ...SpeziSteartIds, ...LeiterSpeziSteartIds],
		},
		{
			name: 'Agenturen',
			icon: 'briefcase',
			path: 'agt',
			nodes: [
				{
					name: 'AdZ Empfehlungen',
					icon: '',
					path: 'adzempfehlung',
					visibileForRoles: [Steart.DVSADMIN],
				},
				{
					name: 'Schwerpunkt',
					icon: '',
					path: 'schwerpunkt',
				},
				{
					name: 'Segmentierung',
					icon: '',
					path: 'segement',
				},
			],
		},
		{
			name: 'Learning',
			icon: 'graduation-cap',
			path: 'learning',
			visibileForRoles: [Steart.VBL, Steart.DVSADMIN],
			nodes: [
				{
					name: 'Podcast',
					icon: '',
					path: 'podcast',
					visibileForRoles: [Steart.VBL, Steart.DVSADMIN],
				},
			],
		},
	],
};
